/* ================================================================
   ResearchPanel — Tabbed sidebar merging Bookmarks + Highlights
   into a single "Research" panel.
   ================================================================ */

import BookmarksPanel from './Bookmarks';
import HighlightsPanel from './HighlightsPanel';

interface Props {
  activeTab: 'bookmarks' | 'highlights';
  onTabChange: (tab: 'bookmarks' | 'highlights') => void;
  onLoadBookmark: (queryId: string) => void;
  onJumpToMessage: (msgId: string) => void;
  onClose: () => void;
  onOpenReportBuilder: () => void;
  refreshKey: number;
  onHighlightsChanged: () => void;
  onBookmarkChange: () => void;
}

export default function ResearchPanel(props: Props) {
  return (
    <div className="research-panel">
      <div className="research-panel-header">
        <h2 className="research-panel-title">Research</h2>
        <button className="research-panel-close" onClick={props.onClose} aria-label="Close">✕</button>
      </div>
      <div className="research-tabs">
        <button
          className={`research-tab ${props.activeTab === 'bookmarks' ? 'research-tab--active' : ''}`}
          onClick={() => props.onTabChange('bookmarks')}
        >
          Bookmarks
        </button>
        <button
          className={`research-tab ${props.activeTab === 'highlights' ? 'research-tab--active' : ''}`}
          onClick={() => props.onTabChange('highlights')}
        >
          Highlights
        </button>
      </div>

      <div className="research-tab-content">
        {props.activeTab === 'bookmarks' && (
          <>
            <BookmarksPanel
              onLoadBookmark={props.onLoadBookmark}
              onClose={props.onClose}
              embedded={true}
              onBookmarkChange={props.onBookmarkChange}
            />
            <button className="research-build-report-btn" onClick={props.onOpenReportBuilder}>
              📄 Build Report from Bookmarks
            </button>
          </>
        )}
        {props.activeTab === 'highlights' && (
          <HighlightsPanel
            onJumpToMessage={props.onJumpToMessage}
            onClose={props.onClose}
            refreshKey={props.refreshKey}
            onHighlightsChanged={props.onHighlightsChanged}
            embedded={true}
          />
        )}
      </div>
    </div>
  );
}
